<script lang="ts">
  import type { CommentAttachment } from "../../comments/CommentTypes";
  import ImageAttachment from "./ImageAttachment.svelte";
  import GameAttachment from "./GameAttachment.svelte";
  import LinkAttachment from "./LinkAttachment.svelte";
  import VideoAttachment from "./VideoAttachment.svelte";
  import SVG from "../../SVG_svelte.svelte";
  import css from '../../../../css/comments.pcss.json'
  import Loading_svelte from "../../Loading_svelte.svelte";

  export let attachment: CommentAttachment
  export let onlyAttachment: boolean = false
  export let removeAttachment: () => void

  let Component: typeof LinkAttachment | typeof ImageAttachment | typeof VideoAttachment | typeof GameAttachment = LinkAttachment
  $: {
    switch (attachment.type) {
      case 'image':
        Component = ImageAttachment
        break
      case 'video':
        Component = VideoAttachment
        break
      case 'game':
        if (attachment.gameInfo) {
          Component = GameAttachment
        }
        break
    }
  }

  const clickHandler = (e: MouseEvent) => {
    e.preventDefault()
    removeAttachment()
  }
</script>

<svelte:component
    this={Component}
    attachment={attachment}
    onlyAttachment={onlyAttachment}
>
    {#if attachment.uploading}
        <div class={css['comment__attachment__uploading']}>
            <Loading_svelte string='' />
        </div>
    {/if}
    <button
        type="button"
        slot="delete"
        on:click={clickHandler}
        class={css['comment__attachment__remove']}
    >
        <SVG i="sg-new/trash" adaptive/>
    </button>
</svelte:component>
<input type="hidden" name="attachment_info[]" value={JSON.stringify(attachment)}/>
